import React from "react";
import { Users, Target, Lightbulb } from "lucide-react";

const SectionCard = ({ title, icon, text, color }) => {
  return (
    <div
      className={`bg-white rounded-3xl p-8 border transition-all duration-500 hover:shadow-2xl hover:scale-105 border-gray-200 hover:border-[${color}]`}
    >
      <div
        className="flex items-center justify-center mb-5 w-16 h-16 mx-auto rounded-full"
        style={{ backgroundColor: color }}
      >
        <div className="text-white text-2xl">{icon}</div>
      </div>

      <h3 className="text-2xl font-bold mb-3 text-center text-gray-800">
        {title}
      </h3>
      <p className="text-gray-600 text-center">{text}</p>
    </div>
  );
};

const AboutUs = () => {
  return (
    <div className="bg-gradient-to-br from-purple-50 via-blue-50 to-teal-50 py-20 px-6 lg:px-12">
      {/* Heading */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-5xl font-extrabold text-[#2D1E5F] mb-4 tracking-wide">
          About Us
        </h2>
        <p className="text-2xl text-gray-700 max-w-3xl mx-auto">
          Empowering students with smart resources, effective mentoring, and confidence for selective exams.
        </p>
      </div>

      {/* Section Cards */}
      <div className="grid md:grid-cols-3 gap-12 max-w-7xl mx-auto">
        <SectionCard
          title="Our Mission"
          icon={<Target size={28} />}
          color="#7C3AED"
          text="Our mission is to provide resources, practice tests, and mentoring to students preparing for OC and Selective exams."
        />
        <SectionCard
          title="Our Approach"
          icon={<Lightbulb size={28} />}
          color="#FACC15"
          text="We use a personalized and data-driven model with weekly tests, instant feedback, and 1-on-1 mentoring for student success."
        />
        <SectionCard
          title="Our Team"
          icon={<Users size={28} />}
          color="#0D9488"
          text="Our team includes passionate educators, mentors, and strategists committed to transforming exam preparation."
        />
      </div>

      {/* Meet the Team */}
      <div className="mt-24 text-center">
        <h3 className="text-4xl font-bold text-black-500 mb-10">Meet the Team</h3>
        <div className="flex flex-wrap justify-center gap-12">
          {[
            { name: "Sarah Malik", role: "Lead Mentor", bg: "bg-purple-200", text: "text-purple-800" },
            { name: "Omar Khan", role: "Test Strategist", bg: "bg-yellow-200", text: "text-yellow-800" },
            { name: "Ayesha Ahmed", role: "Academic Advisor", bg: "bg-teal-200", text: "text-teal-800" },
          ].map((member, i) => (
            <div
              key={i}
              className={`w-80 p-8 rounded-3xl ${member.bg} shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-500`}
            >
              <div className="w-24 h-24 mx-auto mb-5 rounded-full bg-white shadow-inner flex items-center justify-center text-2xl font-bold text-gray-500">
                {member.name.split(" ")[0][0]}{member.name.split(" ")[1][0]}
              </div>
              <h4 className={`text-2xl font-semibold ${member.text}`}>{member.name}</h4>
              <p className="text-md text-gray-600">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
